import { render, staticRenderFns } from "./Brokers.vue?vue&type=template&id=2b176626&scoped=true"
import script from "./Brokers.vue?vue&type=script&lang=js"
export * from "./Brokers.vue?vue&type=script&lang=js"
import style0 from "./Brokers.vue?vue&type=style&index=0&id=2b176626&prod&scoped=true&lang=css"
import style1 from "./Brokers.vue?vue&type=style&index=1&id=2b176626&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b176626",
  null
  
)

export default component.exports